import React from "react";
import PropTypes from "prop-types";
import BookedTicketItems from "@components/Bookings/BookedTicketItems";
import BookedTicketSavings from "@components/Bookings/BookedTicketSavings";
import BookedTicketTotal from "@components/Bookings/BookedTicketTotal";
import "./style.scss";

const BookingDetails = ({ ticket, session }) => {
    return (
        <div className="booking-details">
            <div className="booking-details__list">
                <BookedTicketItems ticket={ticket}/>
                <BookedTicketSavings ticket={ticket} session={session} />
                {ticket.payment_gateway_surcharge_cents > 0 && (
                    <div className="booked-ticket-surcharge">
                        <div key={ticket.id} className="booked-ticket-surcharge__item booking-details__item--surcharge">
                            Payment Gateway Surcharge: ${(ticket.payment_gateway_surcharge_cents / 100).toFixed(2)}
                        </div>
                    </div>
                )}
                <BookedTicketTotal ticket={ticket}/>
            </div>
        </div>
    );
};

BookingDetails.propTypes = {
    ticket: PropTypes.object,
    session: PropTypes.object,
};

export default BookingDetails;
